import config from '../../config';
import localStorage from 'localstorage-ttl';
import deploymentModules from './EditorModule.APP_ENV.ajs?preParser=processEditorModule';

const EDITOR_KEY = 'apEditorModulesList';
const CACHE_TIME_IN_MS = 1000*60*60; // cache for 1 Hour

const firstSort = function(a, b) {
    var aChuncksCount = a.friendly_url.split('/').length;
    var bChuncksCount = b.friendly_url.split('/').length;
    if ( aChuncksCount > bChuncksCount) {
        return -1;
    } else if (aChuncksCount === bChuncksCount ) {
        return 0;
    } else {
        return 1;
    }
}

const secondSort = (a, b) => b.friendly_url.length - a.friendly_url.length;

const cacheModules = () => {
    try {
        $.get(`${config.apiBase}/PBWW/printbox/editor_modules`)
        .then(function(response) {
            const sortedData = response.data.sort(firstSort).sort(secondSort)
            localStorage.set(EDITOR_KEY, {data: sortedData}, CACHE_TIME_IN_MS)
        }).catch(function(e) {
            console.log(e);
        })
    } catch (error) {
        
    }
}

var EditorModule = localStorage.get(EDITOR_KEY);

if (!EditorModule) {
    cacheModules();
    var sortedData = deploymentModules.data.sort(secondSort);
    EditorModule = {data: sortedData};
}

export default EditorModule;


// WEBPACK FOOTER //
// ./src/remoteContent/EditorModule.js